module.exports = __webpack_public_path__ + "static/media/splash-bar-backing.9fe54562.png";